import { render, staticRenderFns } from "./CreateOrder.vue?vue&type=template&id=2b08ddb6&scoped=true&"
import script from "./CreateOrder.vue?vue&type=script&lang=js&"
export * from "./CreateOrder.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrder.vue?vue&type=style&index=0&id=2b08ddb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b08ddb6",
  null
  
)

export default component.exports